/**
 * Marinovel 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

export const theme = {
  homeBg: '/images/marinovel/bg.png',
  tagsBg: '',

  tagActiveBg: '#2C70FF',
  tagActiveText: '#FFFFFF',

  tagInactiveBg: '#EEF4FF',
  tagInactiveText: '#2C70FF',

  tabActiveGradient: 'linear-gradient(270deg, #F6F7F9 0%, #2C70FF 95%)',
  tabActiveColor: '#2C70FF',
  showTabUnderline: true,
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
